export default __webpack_public_path__ + "74c273f2f33c45973e4964d7aa5b4ae2.png";